<template>
  <div class="category-block">
    <div
      v-if="imageLoading"
      class="d-flex justify-content-center"
      style="margin-top: 6%; height: 150px; align-items: center"
    >
      <div class="spinner-border" role="status" style="">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <img
      v-show="!imageLoading"
      @load="imageLoading = false"
      class="category-image"
      :src="category.url"
      alt="Category Image"
    />
    <h2 class="category-title">{{ category.title.toUpperCase() }}</h2>
  </div>
</template>

<script>
export default {
  name: "SliderCategoryBlock",
  data() {
    return {
      imageLoading: true,
    };
  },
  props: {
    category: {
      type: Object,
      default() {
        return {
          id: 0,
          title: "",
          url: "",
          items: [
            {
              id: 0,
              title: "",
              description: "",
              price: "",
              allergens: null,
              url: "",
              url_low: "",
            },
          ],
        };
      },
    },
  },
  methods: {},
};
</script>

<style scoped>
.category-block {
  width: 150px; /* adjust as needed */
  height: 100px; /* adjust as needed */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f8f8f8; /* adjust as needed */
  border-radius: 10px;
  overflow: hidden;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
}

.category-image {
  width: 100%;
  height: 70%; /* adjust as needed */
  object-fit: cover;
  border-radius: 10px 10px 0 0;
  object-position: center;
}

.category-title {
  margin-top: 10px;
  font-size: 0.8em; /* adjust as needed */
  text-transform: uppercase;
  color: #333; /* adjust as needed */
}
</style>
